import { NavigationItem } from '@beautyapp/layout';

export const navigation: NavigationItem[] = [
  {
    id: 'organization',
    title: 'ორგანიზაცია',
    translate: 'NAV.organization',
    type: 'item',
    icon: 'apartment',
    url: '/admin/organization',
    role: ['Admin', 'Manager'],
  },
  {
    id: 'rooms',
    title: 'ოთახები',
    translate: 'NAV.rooms',
    type: 'item',
    icon: 'cluster',
    url: '/admin/room-management',
    role: ['Admin', 'Manager'],
  },
  {
    id: 'booking-sources',
    title: 'ჯავშნის წყაროები',
    translate: 'NAV.booking-sources',
    type: 'item',
    icon: 'merge',
    url: '/admin/booking-sources',
    role: ['Admin', 'Manager'],
  },
  {
    id: 'loyalty',
    title: 'მომხმარებლის სტატუსი',
    translate: 'NAV.USER_Loyalty',
    type: 'item',
    icon: 'star',
    url: '/admin/loyalty',
    role: ['Admin', 'Manager'],
  },
  {
    id: 'offers',
    title: 'შეთავაზებები',
    translate: 'NAV.offers',
    type: 'item',
    icon: 'gift',
    url: '/admin/offers',
    role: ['Admin', 'Manager'],
  },
  {
    id: 'terms',
    title: 'ვერიფიკაციის პირობები',
    translate: 'NAV.terms',
    type: 'item',
    icon: 'safety',
    url: '/admin/terms',
    role: ['Admin', 'Manager'],
  },
  {
    id: 'ehr-template',
    title: 'EHR Templates',
    translate: 'NAV.ehrTemplate',
    type: 'group',
    icon: 'reconciliation',
    url: '/admin/templates',
    // Mirrors the route guard in admin.routes.ts.
    role: ['Admin', 'Administrator', 'Manager'],
  },
  // {
  //   id: 'terms',
  //   title: 'EHR კითხვარები',
  //   translate: 'NAV.questionary-builder',
  //   type: 'item',
  //   icon: 'reconciliation',
  //   url: '/admin/questionary-builder',
  //   role: ['Admin', 'Manager'],
  // },
  {
    id: 'agreement-templates',
    title: 'თანხმობები',
    translate: 'NAV.agreement-templates',
    type: 'item',
    icon: 'reconciliation',
    url: '/admin/agreement-templates',
    role: ['Admin', 'Manager'],
  },
  {
    id: 'user-sources',
    title: 'მომხმარებლის წყაროები',
    translate: 'NAV.user-sources',
    type: 'item',
    icon: 'team',
    url: '/admin/user-sources',
    role: ['Admin', 'Manager'],
  },
  {
    id: 'roles',
    title: 'როლები და უფლებები',
    translate: 'NAV.roles',
    type: 'item',
    icon: 'safety-certificate',
    url: '/admin/roles',
    role: ['Admin', 'Manager'],
  },
  {
    id: 'custom-field-definitions',
    title: 'დამატებითი ველები',
    translate: 'NAV.custom-field-definitions',
    type: 'item',
    icon: 'form',
    url: '/admin/custom-field-definitions',
    role: ['Admin', 'Manager'],
  },
  // beaut-491. Here rather than in the main menu: a data-hygiene tool one
  // person opens occasionally, beside the other settings screens, not beside
  // the daily work.
  {
    id: 'customer-duplicates',
    title: 'განმეორებადი ნომრები',
    translate: 'NAV.customer_duplicates',
    type: 'item',
    icon: 'usergroup-delete',
    url: '/admin/customer-duplicates',
    role: ['Admin', 'Manager'],
  }
];
